// src/utils/mixpanel.js
import mixpanel from "mixpanel-browser";

const TOKEN = "8302dd7d83b16a7053e28a6d951603ba";
mixpanel.init(TOKEN, {
  debug: process.env.NODE_ENV === "development",
});

// simple throttle helper
function throttle(fn, wait) {
  let last = 0;
  return (...args) => {
    const now = Date.now();
    if (now - last >= wait) {
      last = now;
      fn(...args);
    }
  };
}

function extractUtmParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_term: params.get("utm_term"),
    utm_content: params.get("utm_content"),
  };
}

// enrich every event with URL, referrer, UA string, screen size, UTMs
function defaultProps() {
  return {
    url: window.location.href,
    referrer: document.referrer,
    user_agent: navigator.userAgent,
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    ...extractUtmParams(),
  };
}

export function trackEvent(eventName, props = {}) {
  mixpanel.track(eventName, {
    url: window.location.href,
    ...defaultProps(),
    ...props,
  });
}

export function trackPageView() {
  trackEvent("Page Viewed");
}

export function registerClickTracking() {
  document.addEventListener("click", (e) => {
    const el = e.target.closest("a, button");
    if (!el) return;
    const tag = el.tagName.toLowerCase();
    const text = el.innerText.trim() || el.getAttribute("aria-label") || "";
    const href = tag === "a" ? el.href : undefined;
    trackEvent("Element Clicked", { tag, text, href });
  });
}

// 1. Scroll depth (25%, 50%, 75%, 100%)
export function registerScrollDepth() {
  const thresholds = [25, 50, 75, 100];
  const sentinel = {};
  function onScroll() {
    const pct = Math.floor(
      (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100
    );
    thresholds.forEach((t) => {
      if (pct >= t && !sentinel[t]) {
        sentinel[t] = true;
        trackEvent("Scroll Depth", { depth: t });
      }
    });
  }
  window.addEventListener("scroll", throttle(onScroll, 500));
}

// 2. Time on page (fires when user leaves)
export function registerTimeOnPage() {
  let start = Date.now();
  window.addEventListener("beforeunload", () => {
    const ms = Date.now() - start;
    trackEvent("Time on Page", { seconds: Math.round(ms / 1000) });
  });
}

// 3. Form submits
export function registerFormTracking() {
  document.addEventListener("submit", (e) => {
    const name = e.target.name || e.target.id || "unnamed_form";
    trackEvent("Form Submitted", { form: name });
  });
}

// 4. JS errors
export function registerErrorTracking() {
  window.addEventListener("error", (err) => {
    trackEvent("JS Error", {
      message: err.message,
      filename: err.filename,
      lineno: err.lineno,
    });
  });
}
